import Vue from "vue";

Vue.component("service-management", {
    props: ["level", "services", "party", "modificationModel"],    
    data() {
        return {
            selected: null,
            loading: false,
            partyCode: this.party,
            revisionModel: this.modificationModel,
            contextId: '0|0|0'
        };
    },
    methods: {
        showMetadata(model) {
            const self = this;

            if (model != null) {
                self.selected = model;
                self.$refs.fieldEditor.initialize(model.id);
            }
        }
    },
    watch: {
        contextId: function (context) {
            const self = this;

            if (context != null && context != undefined && context != '0|0|0') {
                const splitted = context.split('|');
                if (splitted != null && splitted[0] != null && splitted[1] != null) {
                    if (splitted[1] == '0') {
                        self.$refs.fieldEditor.initialize(splitted[0]);
                    }
                    else {
                        self.revisionModel.updatedServiceCount += 1;
                        self.$emit('update:modificationModel', self.revisionModel);
                    }
                }
            }
        }
    },
    computed: {
        referenceStyle: function () {
            return `margin-left:${(this.level * 40)}px; cursor: pointer;`;
        },
        coverageExclusionTooltipLabel: function () {
            return window.labels.coverageExclusionTooltip;
        }
    },
    template: `
		<div>
			<div v-for="service in services" :data-id="service.id" :id="'service_' + service.id" :key="service.id" class="row is-full">
				<div class="columns mb-0">
					<div v-if="service.referenceNumber != null" class="column column-service-reference-number p-2" :style="referenceStyle" @click="showMetadata(service)">{{ service.referenceNumber }}</div>
                    <i v-if="service.excluded" class="fas fa-ban mt-4 has-text-danger" :title="coverageExclusionTooltipLabel"></i>
					<div style="cursor: pointer" class="column column-service-text p-2" v-html="service.text" @click="showMetadata(service)"></div>
				</div>
				<service-management v-if="service.children && service.children.length > 0" :level="level + 1" :services="service.children" :modification-model.sync="revisionModel" :party="partyCode"></service-management>
				<div v-if="service.items.length > 0" class="column" :style="referenceStyle">
					<service-item-management :service="service" :contextId.sync="contextId" :party="partyCode"></service-item-management>
				</div>
			</div>			
			<service-basic-info-editor ref="fieldEditor" :useModal="true" :party="partyCode" :contextId.sync="contextId"></service-basic-info-editor>			
		</div>
	`
});